<template>
  <div class="welcome-container">
    <MobileHeader @route-change="onRouteChange"></MobileHeader>
    <el-row>
      <h1>科技创新与知识产权</h1>
    </el-row>

    <div class="welcome-swiper-container" style="width: 100%">
      <div class="swiper-wrapper" style="width: 100%">
        <!-- Slides -->
        <div
          class="swiper-slide"
          v-for="item in piclist"
          v-bind:key="item"
          style="width: 100%"
          @click="onBannerClick(item)"
        >
          <img :src="item.url" style="height: 70%; width: 90%" />
          <div class="text-center" style="z-index: 9999">
            <div class="text-xll text-black text-bold">
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MobileHeader from "../../components/MobileHeader";
import Swiper from "swiper/bundle";

export default {
  name: "MobileIntellectual",
  components: { MobileHeader },
  data() {
    return {
      piclist: [
        {
          id: 0,
          type: "image",
          url:
            "https://www.ccsht.cn/resources/static/images/intell/%E5%86%9C%E4%B8%9A%E7%89%A9%E8%81%94%E7%BD%91%E7%9B%91%E6%B5%8B%E7%B3%BB%E7%BB%9F.jpg",
          title: "农业物联网监测系统",
        },
        {
          id: 1,
          type: "image",
          url:
            "https://www.ccsht.cn/resources/static/images/intell/%E6%99%BA%E6%85%A7%E5%86%9C%E4%B8%9A%E7%BB%BC%E5%90%88%E7%AE%A1%E7%90%86%E4%BA%91%E6%9C%8D%E5%8A%A1%E5%B9%B3%E5%8F%B0.jpg",
          title: "智慧农业综合管理云服务平台",
        },
        {
          id: 2,
          type: "image",
          url:
            "https://www.ccsht.cn/resources/static/images/intell/%E6%99%BA%E8%83%BD%E8%A1%8C%E8%B5%B0%E8%A3%85%E5%A4%87%E7%9B%91%E6%8E%A7%E6%9C%8D%E5%8A%A1%E7%B3%BB%E7%BB%9F.jpg",
          title: "智能行走装备监控服务系统",
        },
        {
          id: 3,
          type: "image",
          url:
            "https://www.ccsht.cn/resources/static/images/intell/IOT-Cloud%E7%BB%88%E7%AB%AF%E6%8E%A5%E5%85%A5%E7%BD%91%E5%85%B3%E6%9C%8D%E5%8A%A1%E7%B3%BB%E7%BB%9F.jpg",
          title: "IOT-Cloud终端接入网关服务系统",
        },
        {
          id: 4,
          type: "image",
          url:
            "https://www.ccsht.cn/resources/static/images/intell/%E5%85%A8%E5%9F%9F%E6%97%85%E6%B8%B8%E4%BA%91%E6%9C%8D%E5%8A%A1-%E6%95%B0%E6%8D%AE%E4%BB%93%E5%BA%93%E5%88%86%E6%9E%90%E7%B3%BB%E7%BB%9F.jpg",
          title: "全域旅游云服务-数据仓库分析系统",
        },
        {
          id: 5,
          type: "image",
          url:
            "https://www.ccsht.cn/resources/static/images/intell/全域旅游云服务-数据仓库分析系统.jpg",
          title: "全域旅游-环潭运营车辆监控系统",
        },
        {
          id: 6,
          type: "image",
          url:
                  "https://www.ccsht.cn/resources/static/images/intell/workflow.jpg",
          title: "办公自动化工作流服务系统",
        },
        {
          id: 7,
          type: "image",
          url:
                  "https://www.ccsht.cn/resources/static/images/intell/OA.jpg",
          title: "办公自动化OA系统",
        },
        {
          id: 8,
          type: "image",
          url:
                  "https://www.ccsht.cn/resources/static/images/intell/监控终端.jpg",
          title: "应用于农业的作业和终端设备的程序软件",
        },
        {
          id: 9,
          type: "image",
          url:
                  "https://www.ccsht.cn/resources/static/images/intell/5A旅游会员管理系统.jpg",
          title: "5A级旅游会员管理系统",
        },
        {
          id: 10,
          type: "image",
          url:
                  "https://www.ccsht.cn/resources/static/images/intell/售票数据管理系统.jpg",
          title: "旅游售票数据管理系统",
        },
        {
          id: 11,
          type: "image",
          url:
                  "https://www.ccsht.cn/resources/static/images/intell/旅游园区监控.jpg",
          title: "旅游园区监控管理系统",
        },
      ],
    };
  },
  mounted() {
    this.initSwiper();
  },
  methods: {
    initSwiper() {
      new Swiper(".welcome-swiper-container", {
        loop: true,
        autoplay: true,
        // If we need pagination
        pagination: {
          el: ".swiper-pagination",
        },
      });
    },
    onRouteChange() {
      this.$emit("route-change");
    },
    onBannerClick() {
      this.$emit("welcome-click");
    },
  },
};
</script>

<style scoped>
.welcome-container {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.welcome-swiper-container {
  width: 100%;
}
</style>